import RequestAbortSignal from '@/Enums/Segments/RequestAbortSignal.enum';
import { useRequestSaver } from '@/hooks/RequestSaver';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectHideWhitelabels } from '@/store/selectors/me.selectors';
import { selectSegmentsFilters } from '@/store/selectors/segments.selectors';
import { selectSharedApiLoading } from '@/store/selectors/sharedApi.selectors';
import { resetSegmentsPageState } from '@/store/slices/segments.slice';
import { getSegments } from '@/store/slices/segments.thunks';
import { getClients, getWhitelabels } from '@/store/slices/sharedApi.slice';
import { Paper } from '@mui/material';
import { useCallback, useEffect } from 'react';
import SegmentsGrid from './Grid';

const Segments = () => {
  const requestSaver = useRequestSaver();
  const dispatch = useAppDispatch();

  const hideWhitelabels = useAppSelector(selectHideWhitelabels);
  const loadingFilterSource = useAppSelector(selectSharedApiLoading);
  const filters = useAppSelector(selectSegmentsFilters);

  useEffect(() => {
    return () => {
      requestSaver.requestSaverAbortAll();
      dispatch(resetSegmentsPageState());
    };
  }, []);

  //#region data requests
  const loadSegments = useCallback(() => {
    dispatch(getSegments(requestSaver.requestSaverSetCancellation(RequestAbortSignal.Segments)));
  }, [dispatch]);

  useEffect(() => {
    if (hideWhitelabels) {
      dispatch(getClients());
    } else {
      dispatch(getWhitelabels());
    }
  }, [dispatch, hideWhitelabels]);

  useEffect(() => {
    if (!loadingFilterSource) {
      loadSegments();
    }
  }, [loadingFilterSource, filters.whitelabels, filters.clients, filters.advertisers, filters.active, loadSegments]);
  //#endregion

  return (
    <Paper className='grid grid-cols-1' sx={{ margin: '30px' }}>
      <SegmentsGrid loadSegments={loadSegments} />
    </Paper>
  );
};

export default Segments;
